const ToastCustomerVerifySuccess = () => {
    return (
        <div>
            <h6>Email verification successful.</h6>
            <p>
                We have successfully verified your account and your ticket has
                been saved.
            </p>
        </div>
    );
};

export default ToastCustomerVerifySuccess;
